import { render, staticRenderFns } from "./TicketSystem.vue?vue&type=template&id=62c4a8f3&scoped=true"
import script from "./TicketSystem.vue?vue&type=script&lang=js"
export * from "./TicketSystem.vue?vue&type=script&lang=js"
import style0 from "./TicketSystem.vue?vue&type=style&index=0&id=62c4a8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4a8f3",
  null
  
)

export default component.exports